module.exports = __webpack_public_path__ + "static/meta/sqs/2023/layout_metadata.b92400c.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2023/meta/layout_metadata.tsv
// module id = Ople
// module chunks = 0